import { useParams, Navigate } from "react-router-dom";
import { ALL_LOCATIONS, LocationContext } from "@/lib/locations";
import { WaitlistPopup } from "@/components/WaitlistPopup";
import FAQPage from "./FAQPage";

/**
 * Wraps the FAQPage with the correct LocationContext
 * based on the :region URL param (e.g. /locations/contra-costa/faq)
 */
const RegionFAQPage = () => {
  const { region } = useParams<{ region: string }>();

  const locationData = ALL_LOCATIONS.find(loc => loc.slug === region);

  if (!locationData) return <Navigate to="/faq" replace />;

  return (
    <LocationContext.Provider value={locationData}>
      <WaitlistPopup />
      <FAQPage />
    </LocationContext.Provider>
  );
};

export default RegionFAQPage;
